import React, { useState } from "react";
import DonateForm from "./DonateForm";
import WebData from "../../../../Helpers/WebData";
import "./Donate.style.css";
import ReactMarkdown from "react-markdown";

const Donate = () => {
  const paragraph =
    "Your donations help us keep our bulls, calves and cows well-cared, rescue the abandoned and orphaned, pay the staff, buy medical care machinery and enhance the facilities. Login now to auto-fill the data.\n\n";
  return (
    <>
      <section id="donateTab">
        <div className="row">
          <div className="col-md-8 donate-content-wrapper">
            <div className="justify-desc pe-md-0 donate-para scrollbar-hide">
              <ReactMarkdown>{paragraph}</ReactMarkdown>
            </div>
            <div className="justify-desc pe-md-0 scollbar-hide">
              <DonateForm />
            </div>
          </div>
          <div className="col-md-4 d-flex align-items-center justify-content-center donate-img-cover mt-10px">
            <div className="donate_image">
              <img
                className="d-flex"
                src={WebData.donateImg}
                alt="donate-image"
                srcset=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Donate;
